import { useNavigate, useParams } from 'react-router-dom';
import { Button, message, Row } from 'antd';

import { usePostRequest, useUserRole } from 'hooks';

import { Links } from 'links';

import { OfferDetails } from 'codegen';

export const CopyOffer = () => {
  const { offerId } = useParams();
  const navigate = useNavigate();

  const [postCopyOffer, { loading }] = usePostRequest<OfferDetails>({
    url: 'offers/details/copy',
    queryParams: { offerId },
    options: {
      onSuccess: ({ data }) => {
        message.success('Offer copied successfully!');
        navigate(`${Links.Offers}/${data.id}`);
      },
    },
  });

  const { isAdmin } = useUserRole();

  if (!isAdmin) {
    return null;
  }

  return (
    <Row justify='end'>
      <Button
        size='small'
        type='primary'
        loading={loading}
        onClick={() => postCopyOffer()}
      >
        Copy this offer
      </Button>
    </Row>
  );
};
